import Main from './views/main';
new Main().vue.then(vue => vue.$mount('#app'));
